module.exports = __webpack_public_path__ + "img/sudan.74d8af5f.svg";